var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"ui-switch",class:{ on: _vm.on },attrs:{"disabled":_vm.disabled,"readonly":_vm.readonly},on:{"click":_vm.onClick}},[_vm._v("\n  "+_vm._s(_vm.on ? 'ON' : 'OFF')+"\n  "),_c('span',{staticClass:"circle"})])}
var staticRenderFns = []

export { render, staticRenderFns }